import { jwtDecode } from 'jwt-decode';
import logger from './logger';

export const getToken = () => {
  return localStorage.getItem('AuthToken');
};

export const getAccessToken = () => {
  return localStorage.getItem('AccessToken');
};

export const getExternalAuthToken = () => {
  return localStorage.getItem('ExternalAuthToken');
};

/**
 * Validates if a JWT token is valid and not expired
 * @param {string} token - JWT token to validate
 * @returns {boolean} - true if valid and not expired
 */
export const isTokenValid = (token) => {
  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);

    // Check if token has expiration claim
    if (!decoded.exp) {
      logger.warn('Token does not have expiration claim');
      return false;
    }

    // Get current time as Unix timestamp (UTC/GMT)
    // Date.now() returns milliseconds since Unix epoch in UTC
    const currentTime = Math.floor(Date.now() / 1000);

    // Check if token is expired or expiring soon (60 second buffer)
    // Both decoded.exp and currentTime are Unix timestamps in UTC/GMT
    const isExpired = decoded.exp < (currentTime + 60);

    if (isExpired) {
      const timeUntilExpiry = decoded.exp - currentTime;
      logger.log(`Token expired or expiring in ${timeUntilExpiry} seconds`);
      return false;
    }

    return true;
  } catch (error) {
    logger.error('Error validating token:', error);
    return false;
  }
};

/**
 * Check if we have all required valid tokens
 * @returns {boolean} - true if all tokens are valid
 */
export const hasValidTokens = () => {
  const authToken = getToken();
  const accessToken = getAccessToken();
  const externalAuthToken = getExternalAuthToken();

  // Both tokens must exist and be valid
  return isTokenValid(authToken) && isTokenValid(accessToken) && isTokenValid(externalAuthToken);
};

/**
 * Clear all authentication tokens
 */
export const clearTokens = () => {
  localStorage.clear();
};

export const getUserRole = () => {
  try {
    const authToken = getToken();
    if (!authToken) {
      return '';
    }
    const decodedToken = jwtDecode(authToken);
    return decodedToken.role.toString();
  } catch (error) {
    logger.error('Error decoding token:', error);
    return '';
  }
};

export const getUserId = () => {
  const authToken = localStorage.getItem('AuthToken');
  if (!authToken) {
    return '';
  }

  try {
    const decodedToken = jwtDecode(authToken);
    return decodedToken && decodedToken.nameid ? decodedToken.nameid.toString() : '';
  } catch (error) {
    logger.error('Invalid token:', error);
    return '';
  }
};
